<template>
  <div>
    <table id="hyperion-price-lists" class="hyperion-price-lists">
      <tbody>
        <tr class="hpl-list-head">
          <th class="hpl-company">Company</th>
          <th class="hpl-price-list">Price List</th>
        </tr>
        <tr v-for="priceList in hyperionPriceLists" :key="priceList.id" class="hpl-list-row">
          <td class="hpl-img">
            <a :href="`${priceList.siteLink}`" target="_blank">
              <img :src="require(`@/assets/images/${priceList.img}`)" :alt="`${priceList.alt}`" :height="priceList.height" :class="`${priceList.class}`" class="company-img">
            </a>
          </td>
          <td class="hpl-price-link">
            <span v-if="priceList.price_list === ''">N/A</span>
            <a v-else :href="`${priceList.price_list}`" target="_blank">Price List</a>
          </td>
        </tr>
      </tbody>
    </table>
    <template v-if="loadingLists">
      <div class="progress">
        <div
          class="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          aria-valuenow="100"
          aria-valuemin="0"
          aria-valuemax="100"
          style="width: 100%; border-radius: 3px;"></div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hyperionPriceLists: [],
      loadingLists: false
    }
  },
  created() {
    this.getPriceLists()
  },
  methods: {
    getPriceLists() {
      this.loadingLists = true
      this.$http.get('/api/hyperion-price-lists').then((r) => {
        this.hyperionPriceLists = r.data.price_lists
        this.loadingLists = false
      }).catch(() => {
        this.loadingLists = true
      });
    },
  }
}
</script>
<style lang="scss" scoped>
#hyperion-price-lists {
  width: 100%;
}
.hyperion-price-lists .hpl-list-head {
  background: #333;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  font-weight: normal;
}
.hyperion-price-lists .hpl-list-head th {
  font-weight: normal;
  padding: 6px;
}
.hyperion-price-lists .row > div {
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: center;
}
.hpl-list-row:nth-child(odd) {
  background: #e4e4e4;
}

.hpl-list-row:nth-child(even) {
  background: #ffffff;
}
.hyperion-price-lists .hpl-list-row .hpl-img {
  min-height: 85px;
  height: 85px;
  text-align: center;
}
.hyperion-price-lists tr > th,
.hyperion-price-lists tr > td {
  border: 1px solid #d0d0d0;
}
.hyperion-price-lists .hpl-list-row .hpl-price-link {
  text-align: center;
}
.hyperion-price-lists .hpl-list-head .hpl-company {
  width: 55%;
}
.hyperion-price-lists .hpl-list-head .hpl-price-list {
  width: 45%;
}
.hpl-img .bc-gray {
  //background-color: gray;
  filter: brightness(35%);
  margin: -40px 0 -40px 0;
}
.progress {
  border-radius: 0;
  justify-content: center;
  margin: 15px;
}
</style>